'use strict'
import axios from "axios";
import store from '../store';

export default class BillingProfile {
    static updateEmail(newEmail) {
        if(process.env.NODE_ENV === 'development') return this.developmentUpdateEmail(newEmail);
        return axios.post( `../${store.getters.getConfig['change_email_url']}`, {
            'email': newEmail
        })
    }

    static developmentUpdateEmail(newEmail) {
        return axios.post('/api/changeBillingProfileEmail', {
            'email': newEmail
        });
    }
}